if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.trigger =
          document.querySelector('.product-form__buy-row') ||
          document.getElementById(`ProductInfo-${this.sectionId}`);
        this.priceEl = this.querySelector('.sticky-add-to-cart__price');
        this.button = this.querySelector('.sticky-add-to-cart__button');
        this.mainPriceId = `price-${this.sectionId}`;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.lastEntry = null;

        if (this.trigger) {
          this.observer = new IntersectionObserver(this.onIntersect.bind(this));
          this.observer.observe(this.trigger);
        }
        this.onBreakpointChange = () => this.lastEntry && this.updateVisibility(this.lastEntry);
        this.mobileQuery.addEventListener('change', this.onBreakpointChange);

        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartSettled.bind(this));
        this.unsubscribeCartError = subscribe(PUB_SUB_EVENTS.cartError, this.onCartSettled.bind(this));

        this.syncWithMainButton();

        this.button?.addEventListener('click', () => {
          this.button.classList.add('loading');
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobileQuery?.removeEventListener('change', this.onBreakpointChange);
        this.unsubscribeVariant?.();
        this.unsubscribeCartUpdate?.();
        this.unsubscribeCartError?.();
      }

      onIntersect(entries) {
        this.lastEntry = entries[0];
        this.updateVisibility(this.lastEntry);
      }

      // Mobile: show whenever the main buy row is off screen - including on first
      // load, when the full-width photo pushes it below the fold - so price and
      // add-to-cart are always one tap away. Desktop: only once scrolled PAST it.
      updateVisibility(entry) {
        const visible = this.mobileQuery.matches
          ? !entry.isIntersecting
          : !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', visible);
        if (visible) document.documentElement.style.setProperty('--sticky-atc-offset', `${this.offsetHeight}px`);
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;

        const mainPrice = document.getElementById(this.mainPriceId);
        if (mainPrice && this.priceEl) this.priceEl.innerHTML = mainPrice.innerHTML;

        const variant = event.data.variant;
        if (this.button) {
          this.button.toggleAttribute('disabled', !variant || variant.available === false);
        }
        this.syncWithMainButton();
      }

      onCartSettled() {
        this.button?.classList.remove('loading');
        this.syncWithMainButton();
      }

      // Mirror the main button's state + label (Agregar al carrito / Agotado /
      // max-in-cart), which product-info.js has already updated for the variant.
      syncWithMainButton() {
        const main = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!main || !this.button) return;
        this.button.toggleAttribute('disabled', main.hasAttribute('disabled'));
        const mainLabel = main.querySelector('span');
        const label = this.button.querySelector('span');
        if (mainLabel && label) label.textContent = mainLabel.textContent.trim();
      }
    }
  );
}
